export default __webpack_public_path__ + "static/media/clock.be950285.svg";